"use client";

import MaxWidthWrapper from "../maxwidthwrapper";
import "./business.css";
import YoutubeIframe from "./youtube-iframe/youtube-iframe";
import { useEffect, useState, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import useIsMobile from "../useIsMobile";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";
export interface BusinessContent {
    id: string;
    videoId: string;
}

type Props = {
    list: string[];
    priorityImage?: boolean;
    priorityContent?: boolean;
};

export const BusinessVideoComponent = ({ list, priorityImage, priorityContent }: Props) => {
    const colorStyle = useContext(ColorStyleContext);
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, skipSnaps: false, align: "center" });
    const [currentActive, setCurrentActive] = useState<string>("");
    const [listVideoID, setListVideoID] = useState<BusinessContent[]>([]);
    const [isMove, setIsMove] = useState<number>(0);
    const isMobile = useIsMobile() ?? undefined;

    const onSelect = useCallback(() => {
        if (!emblaApi) return;
        setIsMove(emblaApi.selectedScrollSnap());
        setCurrentActive(listVideoID[emblaApi.selectedScrollSnap()].id);
    }, [emblaApi]);

    useEffect(() => {
        if (!emblaApi) return;
        emblaApi.on("select", onSelect);
        emblaApi.reInit();
    }, [emblaApi, onSelect]);

    useEffect(() => {
        if (list.length > 0) {
            const newListLoop: BusinessContent[] = [];
            const newList = list.map((value, index) => {
                newListLoop.push({
                    id: `videoId${index}duplicated`,
                    videoId: value,
                });

                if (list.length === 1) {
                    newListLoop.push({
                        id: `videoId${index}duplicated2`,
                        videoId: value,
                    });

                    newListLoop.push({
                        id: `videoId${index}duplicated3`,
                        videoId: value,
                    });
                }

                return {
                    id: `videoId${index}`,
                    videoId: value,
                };
            });
            const allList = [...newList, ...newListLoop];
            setListVideoID(allList);
            setCurrentActive(allList[0].id);
        }
    }, [list]);
    const { hasMouseMoved } = useMouseMovement();

    return priorityContent || hasMouseMoved ? (
        <div style={{ backgroundColor: colorStyle?.contentBg || "#ffffff" }}>
            <MaxWidthWrapper
                className="py-8 relative min-h-[350px] md:min-h-[580px]"
                disabledPadding={true}
                sectionWidth="FLUID"
                contentWidth="FLUID">
                <div className="embla" ref={emblaRef}>
                    <div className="embla__container w-auto whitespace-nowrap mt-7 px-0 mx-0 items-center">
                        {listVideoID.map((item, idx) => (
                            <div
                                key={idx}
                                className={`relative min-w-[84%] md:min-w-[45%] basis-2/6 w-40 mx-2 my-6 bg-slate-400 text-center transition-opacity duration-300 ${
                                    idx === isMove
                                        ? "opacity-100 h-[210px] md:h-[445px]"
                                        : "opacity-50 h-[185px] md:h-[410px]"
                                }`}>
                                {" "}
                                <div className="h-full w-full">
                                    <YoutubeIframe
                                        vid={{ id: item.id, videoId: item.videoId }}
                                        active={currentActive}
                                        isMove={isMove}
                                        priorityImage={idx === 0 ? priorityImage : false}
                                        isMobile={isMobile}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </MaxWidthWrapper>
        </div>
    ) : (
        <>
            {listVideoID.map((item, idx) => (
                <>{item.videoId}</>
            ))}
        </>
    );
};

export default BusinessVideoComponent;
